import { themeTokens } from '../theme';

const {
  screenXSMax,
  screenSMMin,
  screenSMMax,
  screenMDMin,
  screenMDMax,
  screenLGMin,
  screenLGMax,
  screenXLMin,
} = themeTokens;

// JS ports of the parametric LESS responsive mixins. Each emits the same two
// halves the LESS did: viewport `@media` queries and the runtime
// `.responsive-force-*` ancestor overrides (driven by ResponsiveOverrideSubtree).

export const responsiveXsVsSm = (xs, smAndBigger) => ({
  [`@media (max-width: ${screenXSMax}px)`]: xs,
  [`@media (min-width: ${screenSMMin}px)`]: smAndBigger,

  '.responsive-force-xxl &, .responsive-force-xl &, .responsive-force-lg &, .responsive-force-md &, .responsive-force-sm &':
    smAndBigger,
  '.responsive-force-xs &': xs,
});

export const responsiveSmVsMd = (smAndSmaller, mdAndBigger) => ({
  [`@media (min-width: ${screenMDMin}px)`]: mdAndBigger,
  [`@media (max-width: ${screenSMMax}px)`]: smAndSmaller,

  '.responsive-force-xxl &, .responsive-force-xl &, .responsive-force-lg &, .responsive-force-md &':
    mdAndBigger,
  '.responsive-force-sm &, .responsive-force-xs &': smAndSmaller,
});

export const responsiveMdVsLg = (mdAndSmaller, lgAndBigger) => ({
  [`@media (min-width: ${screenLGMin}px)`]: lgAndBigger,
  [`@media (max-width: ${screenMDMax}px)`]: mdAndSmaller,

  '.responsive-force-xxl &, .responsive-force-xl &, .responsive-force-lg &':
    lgAndBigger,
  '.responsive-force-md &, .responsive-force-sm &, .responsive-force-xs &':
    mdAndSmaller,
});

export const responsiveLgVsXl = (lgAndSmaller, xlAndBigger) => ({
  [`@media (min-width: ${screenXLMin}px)`]: xlAndBigger,
  [`@media (max-width: ${screenLGMax}px)`]: lgAndSmaller,

  '.responsive-force-xxl &, .responsive-force-xl &': xlAndBigger,
  '.responsive-force-lg &, .responsive-force-md &, .responsive-force-sm &, .responsive-force-xs &':
    lgAndSmaller,
});

export const responsiveMdVsLgVsXl = (mdAndSmaller, lg, xlAndBigger) => ({
  [`@media (min-width: ${screenXLMin}px)`]: xlAndBigger,
  [`@media (min-width: ${screenLGMin}px) and (max-width: ${screenLGMax}px)`]:
    lg,
  [`@media (max-width: ${screenMDMax}px)`]: mdAndSmaller,

  '.responsive-force-xxl &, .responsive-force-xl &': xlAndBigger,
  '.responsive-force-lg &': lg,
  '.responsive-force-md &, .responsive-force-sm &, .responsive-force-xs &':
    mdAndSmaller,
});

export const responsiveXsVsSmVsXl = (xs, smToLg, xlAndBigger) => ({
  [`@media (min-width: ${screenXLMin}px)`]: xlAndBigger,
  [`@media (min-width: ${screenSMMin}px) and (max-width: ${screenLGMax}px)`]:
    smToLg,
  [`@media (max-width: ${screenXSMax}px)`]: xs,

  '.responsive-force-xxl &, .responsive-force-xl &': xlAndBigger,
  '.responsive-force-lg &, .responsive-force-md &, .responsive-force-sm &':
    smToLg,
  '.responsive-force-xs &': xs,
});
